<template>
  <v-container v-if="this.zamawiajacy && this.rodzajWypowiedzenia" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272846163
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<div class="right-cointainer">
    <p align="right" style="margin-bottom: 10px; font-size: 14px;">
Łódź, dnia {{ aktualnaData() }} r.
    </p>
</div>

<p align="center" style="margin-top:20px;">
    <strong>Rozwiązanie umowy zlecenie za wypowiedzeniem</strong>
</p>
<p>
  Niniejszym rozwiązuje umowę zlecenie nr {{ shortNrUmowy() }}, pomiędzy Tutore Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, {{ zamawiajacy === 'Marcin Grzelak - Prezes Zarządu' ? 'reprezentowanym' : 'reprezentowaną' }} przez {{ zamawiajacy }}, {{ zamawiajacy === 'Marcin Grzelak - Prezes Zarządu' ? 'zwanym' : 'zwaną' }} dalej zleceniodawcą, a Panem/Panią {{ zleceniobiorca }}, zamieszkałym/łą w {{ adresZamieszkania }}, {{ kodPocztowy ? `${kodPocztowy},` : '' }} {{ miasto ? `${miasto},` : '' }} identyfikującym/cą się nr Pesel: {{ pesel }} - zwanym/ą dalej zleceniobiorcą. Rozwiązanie umowy zlecenie następuje za {{ okresWypowiedzeniaOdmiana() }} okresem wypowiedzenia.

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span>{{ zleceniobiorca }}</span><br>
        <span>(Podpis Zleceniobiorcy)</span>
    </div>
    <div class="right-cointainer">
        <span>{{ zamawiajacy }}</span><br>
        <p align="right">(Podpis Zleceniodawcy)</p>
    </div>
</div>
  </td></tr>
  </tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'WypowiedzenieTutore',
  props: {
  },
  data () {
    return {
      dataRozwiazania: '',
      nrUmowy: '',
      zamawiajacy: '',
      zleceniobiorca: '',
      adresZamieszkania: '',
      pesel: '',
      okresWypowiedzenia: '',
      rodzajWypowiedzenia: '',
      kodPocztowy: '',
      miasto: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    },
    dataWypowiedzeniaUmowy () {
      if (this.dataRozwiazania === '' || this.dataRozwiazania === '30-12-1899') {
        return ''
      } else {
        return `${this.dataRozwiazania}`
      }
    },
    okresWypowiedzeniaOdmiana() {
      if(this.okresWypowiedzenia === '5 dni') {
        return '5 dniowym'
      } else {
        return `${this.okresWypowiedzenia}`
      }
    },
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'NauczycielAnimatorLektor':
          shortPosition = 'NauAnimLek'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'Twórca':
          shortPosition = 'Tworca'
          break
        case 'TwórcaMateriałów':
          shortPosition = 'TMat'
          break
        case 'TwórcaFabrykaMateriałów':
          shortPosition = 'TFabMat'
          break
        case 'TwórcaMateriałówNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'MetodykTwórcaNauczyciel':
          shortPosition = 'MetTworcaNau'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        case 'TworcaFabrykaMaterialow':
          shortPosition = 'TFabMat'
          break
          case 'KonsultantTurystyka':
          shortPosition = 'TUR'
          break
          case 'KonsultantCC':
          shortPosition = 'CC'
          break
          case 'KonsultantInfolinia':
          shortPosition = 'INF'
          break
          case 'GrupaWsparciaTechnicznego':
          shortPosition = 'GWT'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/WypowiedzenieTutore.vue